import { useState } from "react";
import { ArrowRight, Mail, Users } from "lucide-react";

const FEATURE_BG =
  "https://static.prod-images.emergentagent.com/jobs/04d02fc6-d01d-49d7-84e6-1c31d05566a1/images/3a081ee14c2a39a62498cffca9cb32cd3a52f3aab9e5539f1f5fe14e444b669c.png";

const SUPPORT_EMAIL = "support@tripzorentals.com";

const buildMailto = (riderEmail) => {
  const subject = encodeURIComponent("Tripzo Rentals — Notify me at launch");
  const body = encodeURIComponent(
    `Hi Tripzo team,\n\nPlease add me to the waitlist and notify me when you launch.\n\nMy email: ${
      riderEmail || "(your email)"
    }\n\nThanks!`
  );
  return `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
};

export const WaitlistSection = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    window.location.href = buildMailto(email.trim());
  };

  return (
    <section
      id="waitlist"
      data-testid="waitlist-section"
      className="relative bg-[#1e2528] py-24 md:py-32 overflow-hidden scroll-mt-24 md:scroll-mt-28"
    >
      {/* Background texture */}
      <div className="absolute inset-0 opacity-[0.18] pointer-events-none">
        <img
          src={FEATURE_BG}
          alt=""
          className="w-full h-full object-cover"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1e2528] via-transparent to-[#1e2528]" />
      </div>

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="text-[10px] md:text-xs tracking-[0.3em] uppercase text-[#e89b1f] flex items-center gap-3 mb-6">
          <span className="inline-block w-8 h-px bg-[#e89b1f]" />
          Early access
        </div>

        <h2 className="font-display uppercase text-[#f7f7f7] text-4xl sm:text-5xl lg:text-7xl tracking-tight leading-[0.9] max-w-3xl">
          Be first in the saddle.
        </h2>

        <p className="mt-6 md:mt-8 max-w-2xl text-base md:text-lg text-[#e6ebed]/75 font-light leading-relaxed">
          Drop your email and tap notify — we'll get back to you with launch-day
          access, founder pricing, and a free first day on any ride from our
          fleet.
        </p>

        <form
          onSubmit={handleSubmit}
          data-testid="waitlist-form"
          noValidate
          className="mt-10 md:mt-14 max-w-2xl"
        >
          <div className="flex flex-col sm:flex-row sm:items-end gap-4 sm:gap-6">
            <label className="flex-1 block">
              <span className="block text-[10px] tracking-[0.3em] uppercase text-[#6f7c84] mb-3">
                Your Email
              </span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                data-testid="waitlist-email-input"
                className="w-full bg-transparent border-0 border-b-2 border-[#3e4b55] focus:border-[#e89b1f] outline-none text-[#f7f7f7] text-lg md:text-2xl font-light py-3 placeholder:text-[#6f7c84] transition-colors rounded-none"
                autoComplete="email"
              />
            </label>

            <button
              type="submit"
              data-testid="waitlist-submit-button"
              className="group inline-flex items-center justify-center gap-3 bg-[#e89b1f] hover:bg-[#ffc543] text-[#1e2528] px-7 py-4 rounded-sm font-medium text-sm tracking-[0.15em] uppercase transition-colors whitespace-nowrap"
            >
              Notify Me
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </button>
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-[#6f7c84]">
            <span className="inline-flex items-center gap-2">
              <Users className="w-3.5 h-3.5 text-[#e89b1f]" />
              Join early riders signing up
            </span>
            <span className="text-[#3e4b55]">·</span>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              data-testid="waitlist-fallback-email"
              className="inline-flex items-center gap-2 hover:text-[#e89b1f] transition-colors"
            >
              <Mail className="w-3.5 h-3.5" />
              or write to {SUPPORT_EMAIL}
            </a>
          </div>
        </form>
      </div>
    </section>
  );
};
